"use client";

import React from "react";
import { useEffect, useState } from "react";
import Breadcrumbs from "@/app/components/breadcrumbs";
import BackBtnDark from "@/app/components/svg/back-btn-dark";
import Link from "next/link";
import PostTime from "@/app/components/svg/posttime";
import VideoPlayer from "@/app/components/videoplayer";
import BlogSidebar from "../blogsidebar";
import BackBtnSmall from "@/app/components/svg/back-btn-small";
import RichTextRenderer from "@/app/components/rich-text-renderer/RichTextRenderer";
import {getStrapiURL} from "../../../helper/image-helper";

interface BlogContentProps {
    title: string;
    image: {
        url: string;
    };
    minRead: string;
    Content: any[];
    videoBlockData: {
        videoBlock?: {
            title: string;
            text: string;
            youtubeVideoId: string;
            videoPoster: {
                url: string;
            };
        }
    };
    recentPosts: Array<{
        id: number;
        title: string;
        minRead: string;
        image: {
            url: string;
        };
        metaData: {
            slug: string;
        };
    }>;
    lang: string;
    breadcrumbs: Array<{
        text: string;
        href?: string;
    }>;
}

const BlogContent: React.FC<BlogContentProps> = ({ title, image, minRead, videoBlockData, Content, recentPosts, lang, breadcrumbs }) => {
    const [bakcBtn, setbakcBtn] = useState(true);

    
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1480) {
                setbakcBtn(false);
            } else {
                setbakcBtn(true);
            }
        };
        
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section className="mt-[16px]">
            <div className="container pb-[48px] max-[576px]:pb-[32px]">
                <Breadcrumbs items={breadcrumbs} style="dark"/>
            </div>
            <div className="container">
                <div className="flex gap-[216px] max-[1480px]:gap-[60px]">
                    <div className="max-w-[744px] max-[1200px]:max-w-full max-[1200px]:w-full">
                        <div className="relative">
                            <div className={`left-[-72px] top-0 ${bakcBtn === false ? 'static' : 'absolute'}`}  >
                                <Link href='/blog/'>
                                    <div className={`flex text-gray-600 text-[12px] items-center ${bakcBtn === true ? 'mb-[20px]' : ''}`}>
                                        {bakcBtn === true ? <BackBtnDark /> : <BackBtnSmall />}
                                        {bakcBtn === true ? '' : 'Back to Blog'}
                                    </div>
                                </Link>
                            </div>
                            <h1 className="text-[32px] text-black-50 font-bold leading-[1.3] max-[576px]:text-[24px]">{title}</h1>
                            <div className="w-full h-[488px] max-[767px]:h-full mt-[16px]">
                                <img className="object-cover rounded-[24px] w-full h-full max-[576px]:rounded-[20px]" src={getStrapiURL(image.url)} alt="" />
                            </div>
                            <p className='mt-[19px] flex items-center gap-[4px] text-[14px] font-medium text-gray-600 leading-[1.5]'>
                                <PostTime />
                                {minRead}
                            </p>
                            <div className="blogcontent">
                                <RichTextRenderer content={Content} />
                                <div className="mb-[30px]">
                                <VideoPlayer videoId={videoBlockData.videoBlock?.youtubeVideoId ?? ""} poster={getStrapiURL(videoBlockData.videoBlock?.videoPoster?.url ?? "")} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* sibedar */}
                    <div className="max-[1200px]:hidden">
                        <BlogSidebar lang={lang} recentPosts={recentPosts} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogContent;